import React from 'react'
import { SortableContext } from '@dnd-kit/sortable'

const SortableList = ({ items, strategy, children }) => (
  <SortableContext items={items} strategy={strategy}>
    {children}
  </SortableContext>
)

export default SortableList
